import React, { useState } from 'react';
import Container from './Container';
import Logo from './Logo';
import DesktopNav from './DesktopNav';
import MobileMenu from './MobileMenu';
import MenuToggle from './MenuToggle';
import AuthButtons from './AuthButtons';
import { navigationItems, authButtons, logoConfig } from '../data/navigation';
export default function Navbar({ 
  className = '',
  headerClassName = 'sticky top-0 z-40 bg-[#FFFFFFE5] backdrop-blur-[18.22px] border-b border-[#0000001A]'
}) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(prev => !prev);
  const closeMenu = () => setIsMenuOpen(false);

  return (
    <header className={`${headerClassName} ${className}`}>
      <Container className="flex h-16 items-center justify-between">
        <Logo {...logoConfig} />
        <DesktopNav items={navigationItems} />
        <AuthButtons buttons={authButtons} />
        <MenuToggle isOpen={isMenuOpen} onToggle={toggleMenu} />
      </Container>
      <MobileMenu 
        isOpen={isMenuOpen} 
        onClose={closeMenu}
        navItems={navigationItems}
        authButtons={authButtons}
      />
    </header>
  );
}


